import { Observable } from "rxjs";

export abstract class ILookupService {
  public abstract getOrganizationList(): Promise<any>;
}
